/**
 * FOCO AI System — Premium Chart Configuration
 * Unified styling for all Recharts components
 */

// Brand-aligned chart palette
export const chartColors = {
  // Primary data series
  navy: 'hsl(218, 45%, 20%)',        // #1B2A4A — primary navy
  blue: 'hsl(204, 64%, 47%)',        // #2E86C1 — accent blue
  emerald: 'hsl(145, 63%, 49%)',     // #2ECC71 — success green
  
  // Secondary palette (softer tones)
  slate: 'hsl(213, 20%, 55%)',       // muted navy
  teal: 'hsl(174, 42%, 51%)',        // teal accent
  amber: 'hsl(38, 80%, 55%)',        // warm amber
  rose: 'hsl(0, 65%, 58%)',          // soft red/destructive
  
  // Semantic
  income: 'hsl(204, 64%, 47%)',      // blue
  expenses: 'hsl(218, 45%, 20%)',    // navy
  savings: 'hsl(145, 63%, 49%)',     // emerald
  debt: 'hsl(0, 55%, 55%)',          // muted red
  investments: 'hsl(174, 42%, 51%)', // teal
};

// Distribution chart palette (ordered for pie/donut)
export const distributionPalette = [
  'hsl(218, 45%, 25%)',   // Gastos Fijos — dark navy
  'hsl(204, 64%, 47%)',   // Gastos Variables — blue
  'hsl(145, 63%, 49%)',   // Ahorros — emerald
  'hsl(174, 42%, 51%)',   // Inversiones — teal
  'hsl(0, 50%, 58%)',     // Deudas — muted rose
];

// Premium tooltip style
export const tooltipStyle: React.CSSProperties = {
  backgroundColor: 'hsl(220, 30%, 98%)',
  border: '1px solid hsl(220, 13%, 91%)',
  borderRadius: '10px',
  padding: '10px 14px',
  boxShadow: '0 4px 20px -4px rgba(27, 42, 74, 0.12)',
  fontSize: '13px',
  lineHeight: '1.5',
};

// Subtle grid stroke
export const gridStroke = 'hsl(220, 13%, 91%)';
export const gridStrokeDasharray = '4 4';

// Axis tick style
export const axisTickStyle = {
  fill: 'hsl(213, 15%, 52%)',
  fontSize: 11,
  fontFamily: 'Inter, sans-serif',
};

// Legend style
export const legendStyle = {
  fontSize: '12px',
  fontFamily: 'Inter, sans-serif',
};
